import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";

type RTKQueryErrorWrapper = {
  error: FetchBaseQueryError | SerializedError;
  isUnhandledError?: boolean;
  meta?: unknown;
};

export function isRTKQueryErrorWrapper(
  error: unknown,
): error is RTKQueryErrorWrapper {
  return typeof error === "object" && error != null && "error" in error;
}

export function isFetchBaseQueryError(
  error: unknown,
): error is FetchBaseQueryError {
  return typeof error === "object" && error != null && "status" in error;
}
